import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_15: FaireProductEntity = {
  token: "toysmith-15",
  type: "product",
  name: "Beetle & Bee Little Birder Set-Bird Watching for Kids",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/ea2ea5878c9ac3fcbef1561778d065a7d3aac8992358db9a4687ee00093259d4.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1560,1562,x0,y118,safe&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
